"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./virtual-select");
const select = {
    /**
     * Initialises the functionality.
     */
    init: function (el) {
        window.VirtualSelect.init({
            ele: el,
            optionHeight: 48
        });
    },
};
exports.default = select;
